import { Button, ButtonBase, IconButton } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { Transition, motion, useDomEvent } from "motion/react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TbDownload, TbZoom } from "react-icons/tb";

import { downloadImage } from "@/helpers/download";

const transition: Transition = {
    type: "spring" as const,
    damping: 25,
    stiffness: 120,
};

export const Image = ({ imageUrl }: { imageUrl: string }) => {
    const [isOpen, setOpen] = useState(false);

    const { t } = useTranslation();
    useDomEvent(useRef(window), "scroll", () => isOpen && setOpen(false));

    return (
        <div className={`image-container ${isOpen ? "open" : ""}`}>
            <motion.div
                animate={{ opacity: isOpen ? 1 : 0 }}
                transition={transition}
                className="shade"
                onClick={() => setOpen(false)}
            >
                <IconButton
                    aria-label="close"
                    onClick={() => void 0}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <GridCloseIcon />
                </IconButton>
            </motion.div>
            <div className="!relative w-full group  ">
                <div className="flex gap-2 group-hover:translate-x-0 translate-x-full duration-200 opacity-0 group-hover:opacity-100 absolute bottom-[102%] right-2 z-50">
                    <Button
                        size="small"
                        startIcon={<TbDownload />}
                        variant="outlined"
                        aria-label="close"
                        onClick={() => {
                            downloadImage(imageUrl);
                        }}
                    >
                        {t("buttons.download")}
                    </Button>
                    <Button
                        size="small"
                        startIcon={<TbZoom />}
                        variant="outlined"
                        color="success"
                        aria-label="close"
                        onClick={() => setOpen(true)}
                    >
                        {t("buttons.preview")}
                    </Button>
                </div>
                <ButtonBase className=" w-full">
                    <motion.img
                        src={imageUrl}
                        className="!w-full"
                        onClick={() => setOpen(!isOpen)}
                        transition={transition}
                    />
                </ButtonBase>
            </div>
        </div>
    );
};
